import { render, staticRenderFns } from "./UpperLevel.vue?vue&type=template&id=0a5cf44e&scoped=true"
import script from "./UpperLevel.vue?vue&type=script&lang=ts"
export * from "./UpperLevel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5cf44e",
  null
  
)

export default component.exports